import axios from 'axios'
import axiosCancel from 'axios-cancel'

axiosCancel(axios, {
  debug: false // default
})
const requestId = 'bba_api_request'

export function getAxiosConfig (tempRequestId = null, contentType = 'application/json') {
  return {
    withCredentials: true,
    requestId: tempRequestId || requestId,
    headers: {
      'Accept': contentType,
      'Content-Type': contentType
    }
  }
}
export function getLoginUrl () {
  return process.env.VUE_APP_BACKEND_URL + '/security/login'
}
export function getFormationLoginUrl () {
  return process.env.VUE_APP_BACKEND_URL + '/security/formation_login'
}
export function getLogoutUrl () {
  return process.env.VUE_APP_BACKEND_URL + '/security/logout'
}

export function getPingUrl () {
  return process.env.VUE_APP_BACKEND_URL + '/security/ping'
}

export function cancelAxiosRequest () {
  axios.cancel(requestId)
}
